import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../../app/services/user.service';
import { map, takeUntil } from 'rxjs/operators';

interface ProfileViewModel {
  photoUrl: string;
  fullName: string;
  email: string;
  chapter: string;
  post: string;
  tribe: string;
  squad: string;
}
@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit, OnDestroy {

  viewModel: ProfileViewModel;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private authService: AuthService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.getUser()
      .pipe(
        takeUntil(this.destroyed$),
        map(({ photoUrl, fullName, email, tribe, squad, chapter, post }) => ({
          photoUrl,
          fullName,
          email,
          tribe,
          squad,
          chapter,
          post
        }))
      )
      .subscribe(viewModel => {
        this.viewModel = viewModel;
      });
  }

  ngOnDestroy() {
    this.notifyEnd();
  }

  async signOut() {
    this.notifyEnd();
    await this.authService.signOut();
  }

  private notifyEnd() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
